import axios from '../axios'
// 资源分类列表
export const queryConsult = (data) => {
  return axios({
    url: '/information/queryInformationByPage',
    method: 'GET',
    data
  })
}
export const updateConsult = (data) => {
    return axios({
      url: '/information/update',
      method: 'POST',
      data
    })
}
export const operateConsult = (data) => {
    return axios({
      url: '/information/operate',
      method: 'POST',
      data
    })
}
export const deleteConsult = (data) => {
    return axios({
      url: '/information/delete',
      method: 'POST',
      data
    })
}
export const insertConsult = (data) => {
    return axios({
      url: '/information/insert',
      method: 'POST',
      data
    })
}
//查询图片列表
export const imageGet = (data) => {
  return axios({
    url: '/information_image/get',
    method: 'GET',
    data
  })
}
//编辑图片
export const updateImage = (data) => {
  return axios({
    url: '/information_image/update',
    method: 'POST',
    data
  })
}






// WEBPACK FOOTER //
// ./src/http/moudules/informationCenter.js